import { render, staticRenderFns } from "./FaBoxComponent.vue?vue&type=template&id=d83b62ce&"
import script from "./FaBoxComponent.vue?vue&type=script&lang=ts&"
export * from "./FaBoxComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports